import React from "react";
import classNames from "classnames";

import { ScreenWatcher } from "@common/screenWatcher";
import { LayoutWatcher } from "@common/layoutWatcher";
import { Props } from "./types";
import styles from "./styles.scss";

function ScrollPane({ className, children }: Props) {
  return (
    <ScreenWatcher
      renderChildren={({ height }) => (
        <LayoutWatcher
          renderChildren={({ top }) => {
            const maxHeight = height - top - 60;

            return (
              <div
                className={classNames(styles.scrollPane, {
                  [`${className}`]: !!className,
                })}
                style={{
                  maxHeight:
                    maxHeight < 300 && maxHeight > 100 ? maxHeight : 300,
                }}
              >
                {children}
              </div>
            );
          }}
        />
      )}
    />
  );
}

export { ScrollPane };
